import getContentEditableCaretPosition from './getContentEditableCaretPosition';

const extractSuggestionContent = (input) => {
  if (!input) {
    return { delimiter: null, value: null };
  }

  const str = input?.value || input?.textContent;
  const index = input?.selectionStart || getContentEditableCaretPosition(input);

  if (index > str?.length) {
    return { delimiter: null, value: null };
  }

  let lastOpenBracket = -1;
  const state = {
    lastUrlParamStart: -1,
    inUrlParam: false,
    lastSquareUrlParamStart: -1,
    inSquareUrlParam: false
  };

  for (let i = 0; i < index; i++) {
    // Handle double bracket case
    if (str[i] === '{' && str[i + 1] === '{') {
      lastOpenBracket = i + 2;
    } else if (str[i] === '}' && str[i + 1] === '}' && i >= lastOpenBracket) {
      lastOpenBracket = -1;
    }

    // Handle URL parameter cases
    handleUrlParam(str, i, state);
  }

  return determineDelimiterAndValue(str, index, lastOpenBracket, state);
};

function handleUrlParam(str, i, state) {
  // Handle '/' URL parameter case
  if (str[i] === '/' && str[i + 1] === ':') {
    state.lastUrlParamStart = i + 2;
    state.inUrlParam = true;
  } else if (str[i] === '/' && state.inUrlParam) {
    state.inUrlParam = i <= state.lastUrlParamStart;
    if (str[i + 1] === ':') {
      state.lastUrlParamStart = i + 2;
    }
  }

  // Handle '[' URL parameter case
  if (str[i] === '[' && str[i + 1] === ':') {
    state.lastSquareUrlParamStart = i + 2;
    state.inSquareUrlParam = true;
  } else if (str[i] === ']' && state.inSquareUrlParam) {
    state.inSquareUrlParam = i <= state.lastSquareUrlParamStart;
    if (str[i + 1] === ':') {
      state.lastSquareUrlParamStart = i + 2;
    }
  }
}

function determineDelimiterAndValue(str, index, lastOpenBracket, state) {
  if (state.inSquareUrlParam && state.lastSquareUrlParamStart === index) {
    return { delimiter: '/:', value: '' };
  }
  if (state.inUrlParam && state.lastUrlParamStart === index) {
    return { delimiter: '/:', value: '' };
  }
  if (lastOpenBracket !== -1 && lastOpenBracket <= index) {
    return { delimiter: '{{', value: str.substring(lastOpenBracket, index) };
  }
  if (state.inUrlParam && state.lastUrlParamStart !== -1 && state.lastUrlParamStart < index) {
    return { delimiter: '/:', value: str.substring(state.lastUrlParamStart, index) };
  }
  if (state.inSquareUrlParam && state.lastSquareUrlParamStart !== -1 && state.lastSquareUrlParamStart < index) {
    return { delimiter: '/:', value: str.substring(state.lastSquareUrlParamStart, index) };
  }

  return { delimiter: null, value: null };
}

export default extractSuggestionContent;
